export const NAV_LABELS = {
  HOME: 'Home',
  MANAGE_CONTRACT: 'Contracts',
  MY_CMS_APPS: 'My CMS Apps',
  MY_PROFILE: 'Profile',
  NOVA: 'eNOVA',
} as const;

import { ROUTES } from '../../constants';
import { MY_CMS_APPS_URL } from '../../utils/myCmsAppsUrl';

export const NAV_ITEMS = [
  { isExternal: false, label: NAV_LABELS.HOME, path: ROUTES.HOME },
  { isExternal: false, label: NAV_LABELS.MY_PROFILE, path: ROUTES.MY_PROFILE },
  { isExternal: true, label: NAV_LABELS.MY_CMS_APPS, path: MY_CMS_APPS_URL },
  { isExternal: false, label: NAV_LABELS.MANAGE_CONTRACT, path: ROUTES.MANAGE_CONTRACT },
] as const;

export const NAV_CHILD_LABELS = {
  NOVA_APPLICATION: 'Application',
  NOVA_APPLICATION_STATUS: 'Application Status',
  NOVA_APPROVALS: 'Approvals',
} as const;

export const NOVA_CHILDREN = [
  { label: NAV_CHILD_LABELS.NOVA_APPLICATION, path: ROUTES.NOVA_APPLICATION },
  { label: NAV_CHILD_LABELS.NOVA_APPLICATION_STATUS, path: ROUTES.NOVA_APPLICATION_STATUS },
  { label: NAV_CHILD_LABELS.NOVA_APPROVALS, path: ROUTES.APPROVALS },
] as const;
